
export const design = [
        {
            titre: "Création d’un logo",
            texte: "offrons une identité à votre entreprise",
            prix: "100",
            monnaie: "€",
            sous_texte: "à partir de",
            id: "card-details-1-d",
            line1: {
                symbole: "check",
                phrase: "Design + Maquettage",
            },
            line2: {
                symbole: "check",
                phrase: "100% personnalisé",
            },
            line3: {
                symbole: "check",
                phrase: "Retours sur demande",
            },

        },

        {
            titre: "Elaboration d’une carte de visite",
            texte: "votre identité professionnelle à portée de main",
            prix: "150",
            monnaie: "€",
            sous_texte: "à partir de",
            id: "card-details-2-d",
            line1: {
                symbole: "check",
                phrase: "Design + Maquettage",
            },
            line2: {
                symbole: "check",
                phrase: "100% personnalisé",
            },
            line3: {
                symbole: "check",
                phrase: "Retours sur demande",
            },
            line4: {
                symbole: "croix",
                phrase: "Impression",
            },
            line5: {
                symbole: "params",
                phrase: "Adaptabilité à votre charte graphique",
            }
        },

        {
            titre: "Conception d’un flyer ou d’un dépliant",
            texte: "faites passer votre message de manière élégante",
            prix: "200",
            monnaie: "€",
            sous_texte: "à partir de",
            id: "card-details-3-d",
            line1: {
                symbole: "check",
                phrase: "Design + Maquettage",
            },
            line2: {
                symbole: "check",
                phrase: "100% personnalisé",
            },
            line3: {
                symbole: "check",
                phrase: "Retours sur demande",
            },
            line4: {
                symbole: "croix",
                phrase: "Impression",
            },
            line5: {
                symbole: "params",
                phrase: "Adaptabilité à votre charte graphique",
            }

        }
       
    ];
    

export const site_web = [
        {
            titre: "Présentation sur une page web",
            texte: "tout ce qu'il faut savoir sur vous, en une page",
            prix: "800",
            monnaie: "€",
            sous_texte: "à partir de",
            id: "card-details-1-sw",
            line1: {
                symbole: "check",
                phrase: "Design + maquettage",
            },
            line2: {
                symbole: "check",
                phrase: "100% personnalisé",
            },
            line3: {
                symbole: "croix",
                phrase: "Multi-pages",
            },
            line4: {
                symbole: "params",
                phrase: "Formulaire de contact",
            },
            line5: {
                symbole: "params",
                phrase: "Multilingue",
            }
        },
        {
            titre: "Création d’un site web complet",
            texte: "présentez chaque aspect de votre entreprise en détail",
            prix: "1300",
            monnaie: "€",
            sous_texte: "à partir de",
            id: "card-details-2-sw",
            line1: {
                symbole: "check",
                phrase: "Design + maquettage",
            },
            line2: {
                symbole: "check",
                phrase: "100% personnalisé",
            },
            line3: {
                symbole: "check",
                phrase: "Multi-pages",
            },
            line4: {
                symbole: "params",
                phrase: "Formulaire de contact",
            },
            line5: {
                symbole: "params",
                phrase: "Multilingue",
            }
        },

        {
            titre: "Hébergement et maintenance",
            texte: "votre site web, sécurisé et toujours en ligne",
            prix: "50",
            monnaie: "€",
            sous_texte: "/mois",
            id: "card-details-3-sw",
            line1: {
                symbole: "check",
                phrase: "Hébergement en ligne",
            },
            line2: {
                symbole: "check",
                phrase: "Référencement SEO",
            },
            line3: {
                symbole: "check",
                phrase: "Maintenance",
            },
            line4: {
                symbole: "params",
                phrase: "Mise à jour du contenu",
            }
        }
];

